var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loading)?_c('h5',{staticClass:"no-product"},[_vm._v(" We are unable to find the what you were looking for:( ")]):_vm._e(),(_vm.loading)?_c('h5',{staticClass:"no-product"},[_vm._v("Loading...")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }